<template lang="pug">
  select(:id="id" v-bind:value="value" v-on:input="setValue")
    option(v-for="option in options" :value="option[1]") {{option[0]}}
</template>
<style lang="postcss" scoped>
select {
  @apply block appearance-none w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight;
  -webkit-appearance: none;
  background-image: svg-load("../assets/icons/expand.svg");
  background-repeat: no-repeat;
  background-position: 95% center;
  background-size: 20px;
}
</style>
<script>
export default {
  name: "CustomSelect",
  props: {
    value: {
      type: [String, Boolean],
    },
    id: {
      type: String,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    setValue(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>
